import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggedInAsComponent } from './logged-in-as/logged-in-as.component';
import { MatIconModule } from '@angular/material/icon';
import { UserAccessService } from './userAccess.service';
import { ThemeSelectorComponent } from '../shared/ui/theme-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    LoggedInAsComponent,
    ThemeSelectorComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
  ],
  exports: [
    LoggedInAsComponent,
    ThemeSelectorComponent
  ], 
  providers: [
    UserAccessService
  ]
  
})
export class DsCoreModule { }
